import React from 'react';
import { DatePicker as RsDatePicker, DatePickerProps as RsDatePickerProps } from 'rsuite5';
import { format as dateFormat } from 'date-fns';
import { BICESTER_RSUITE5_FULL_DATE_HOURS_MINUTES } from '@/constants/dateFormat';

export interface DatePickerProps extends Omit<RsDatePickerProps, 'onChange'> {
  onChange: (val: any) => void;
}

const DatePickerField = ({
  placeholder = ' ',
  format = BICESTER_RSUITE5_FULL_DATE_HOURS_MINUTES,
  value,
  onChange,
  ...props
}: DatePickerProps) => {
  return (
    <RsDatePicker
      placeholder={placeholder}
      value={value && new Date(value)}
      format={format}
      ranges={[]}
      onChange={(val) => {
        if (onChange) {
          val ? onChange(dateFormat(val, format)) : onChange('');
        }
      }}
      oneTap={!format.includes('HH:mm')} // 精确到时分的选择器需要有确定按钮
      {...props}
    />
  );
};

export default DatePickerField;
